import { required } from "react-admin";

interface NumericFieldConfig {
  source: string;
  defaultValue: number;
  label?: string;
}

export const initialNumericFields: NumericFieldConfig[] = [
  { source: "soc_trial_1", defaultValue: 0.2 },
  { source: "soc_trial_3", defaultValue: 0.4571 },
  { source: "soc_trial_2_4", defaultValue: 0.5272 },
  { source: "fcr_engagement_default", defaultValue: 1 },
  { source: "initial_soc_restoration_1_3", defaultValue: 0.1 },
  { source: "initial_soc_restoration_2_4", defaultValue: -0.1 },
];

export const initialFormValidation = {
  number: [required()],
};
